export default __webpack_public_path__ + "static/media/Mtn-logo-svg.svg.6e71e8c0.png";